import { FC } from "react";

import { FormType } from "@simplyk/common";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormChip } from "@/forms-design-system/FormChip";

export const TicketingClosedChip: FC = () => {
  const { t } = useTranslate();
  const { formObject } = useFormV2Context(FormType.Ticketing);
  const { isTicketingClosed: ticketingIsClosed } = useFormV2Context(FormType.Ticketing);

  if (!formObject.isArchived && !ticketingIsClosed) {
    return null;
  }

  return (
    <FormChip
      vibe="danger"
      variant="outlined"
      label={t("ticketing", "salesClosed")}
      data-test="closed-status"
      sx={{ alignSelf: "flex-start" }}
    />
  );
};
